"use client";

import {
  __objRest
} from "./chunk-TOX7GYF3.mjs";

// src/create-context.tsx
import * as React from "react";
import { jsx } from "react/jsx-runtime";
function createContext2(rootComponentName, defaultContext) {
  const Context = React.createContext(
    defaultContext
  );
  function Provider(props) {
    const _a = props, { children } = _a, context = __objRest(_a, ["children"]);
    const value = React.useMemo(
      () => context,
      // eslint-disable-next-line react-hooks/exhaustive-deps
      Object.values(context)
    );
    return /* @__PURE__ */ jsx(Context.Provider, { value, children });
  }
  function useContext2(consumerName) {
    const context = React.useContext(Context);
    if (context)
      return context;
    if (defaultContext !== void 0)
      return defaultContext;
    throw new Error(
      `\`${consumerName}\` must be used within \`${rootComponentName}\``
    );
  }
  Provider.displayName = rootComponentName + "Provider";
  return [Provider, useContext2];
}

export {
  createContext2 as createContext
};
